<template>
  <el-form
    ref="form"
    class="filter-form"
    label-position="top"
    :model="filters"
  >
    <el-form-item label="Поиск">
      <el-input
        v-model="filters.search"
        v-debounce="doFilter"
        placeholder="Поиск"
        prefix-icon="el-icon-search"
      />
    </el-form-item>
    <el-button
      v-if="isFiltersChanged"
      type="gray"
      @click="clearFilters"
    >
      Сбросить фильтры
    </el-button>
  </el-form>
</template>

<script>

const defaultFilterValues = {
  search: '',
}

const STORAGE_KEY = 'offers_trash_filters'

export default {
  name: 'FilterOffersTrash',
  data() {
    return {
      filters: {...this.loadFiltersFromStorage()},
      originFilters: {...defaultFilterValues},
    }
  },

  computed: {
    isFiltersChanged() {
      return JSON.stringify(this.originFilters) !== JSON.stringify(this.filters)
    },
  },
  mounted() {
    this.$emit('filter', this.filters)
  },
  methods: {
    loadFiltersFromStorage() {
      try {
        const savedFilters = localStorage.getItem(STORAGE_KEY)
        if (savedFilters) {
          const parsedFilters = JSON.parse(savedFilters)
          // Merge with defaults to ensure all required properties exist
          return { ...defaultFilterValues, ...parsedFilters }
        }
      } catch (error) {
        console.warn('Failed to load filters from localStorage:', error)
      }
      return { ...defaultFilterValues }
    },

    saveFiltersToStorage() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.filters))
      } catch (error) {
        console.warn('Failed to save filters to localStorage:', error)
      }
    },

    clearFiltersFromStorage() {
      try {
        localStorage.removeItem(STORAGE_KEY)
      } catch (error) {
        console.warn('Failed to clear filters from localStorage:', error)
      }
    },

    async doFilter() {
      this.saveFiltersToStorage()
      this.$emit('filter', this.filters)
    },
    async clearFilters() {
      this.filters = {...defaultFilterValues}
      this.clearFiltersFromStorage()
      this.$emit('filter', this.filters)
    },
  },
}

</script>

<style scoped>

</style>
